import React from "react";
import {
  ColumnDefinition,
  ElementWithId,
  SortFnType,
} from "./MeasureTableTypes";
import {
  Tbl,
  TblBody,
  TblBodyCell,
  TblBodyRow,
  TblHead,
  TblHeadCell,
  TblHeadRow,
} from "./PlainTable";

const WorkflowInputTable = <T extends ElementWithId>(props: {
  width?: string;
  maxHeight?: string;
  selectedRow?: T;
  keyFn?: (row?: T) => string;
  columns: ColumnDefinition<T>[];
  items: T[];
  className?: string;
}) => {
  const { columns, items, keyFn } = props;
  const [sortDirection, setSortDirection] = React.useState<"up" | "down">(
    "down"
  );
  const [sortFn, setSortMethod] = React.useState<
    undefined | { fn: SortFnType }
  >();

  const keyFunction = props.keyFn ? props.keyFn : (item?: T) => item?.id || "";

  const sortedItems = React.useMemo(() => {
    if (!sortFn) return items;
    const list = [...items.filter((x) => x)];
    list.sort(sortFn.fn);
    if (sortDirection === "up") {
      list.reverse();
    }
    return list;
  }, [items, sortFn, sortDirection]);

  return (
    <>
      <Tbl
        width={props.width}
        maxHeight={props.maxHeight}
        className={props.className}
      >
        <TblHead>
          <TblHeadRow>
            {columns.map((col) => {
              let cStyle = {
                cursor: col.sortFn ? "pointer" : "unset",
              };

              if (col.title === "Period")
                cStyle = { ...cStyle, ...{ minWidth: "100px" } };
              if (col.title === "Actual")
                cStyle = { ...cStyle, ...{ minWidth: "120px" } };
              const sortClick = () => {
                if (col.sortFn) {
                  if (col.sortFn === sortFn?.fn) {
                    if (sortDirection === "up") {
                      setSortDirection("down");
                    } else {
                      setSortDirection("up");
                    }
                  } else {
                    setSortMethod({ fn: col.sortFn });
                  }
                } else {
                  setSortMethod(undefined);
                }
              };
              if (typeof col.title === "string") {
                return (
                  <TblHeadCell
                    onClick={sortClick}
                    key={col.title}
                    style={cStyle}
                  >
                    {col.title}
                  </TblHeadCell>
                );
              }
              const Title = col.title;
              const keyObj = Object.entries(col).filter(
                ([key, value]) => typeof value === "string"
              );
              return (
                <TblHeadCell
                  key={JSON.stringify(keyObj)}
                  onClick={sortClick}
                  style={cStyle}
                >
                  <Title elem={col} />
                </TblHeadCell>
              );
            })}
          </TblHeadRow>
        </TblHead>
        <TblBody>
          {sortedItems.map((item) => {
            return (
              <TblBodyRow
                key={keyFunction(item)}
                className={
                  keyFunction(props.selectedRow) === keyFunction(item)
                    ? `selected`
                    : ""
                }
              >
                {columns.map((col) => {
                  const Value = col.value;
                  const { onRowClick } = col;
                  return (
                    <TblBodyCell
                      key={`${item.id}${col.title}${col.value}`}
                      onClick={() => {
                        if (onRowClick) {
                          onRowClick(item);
                        }
                      }}
                      style={{ cursor: onRowClick ? "pointer" : undefined }}
                      className={col.tdClassName}
                    >
                      <Value elem={item} />
                    </TblBodyCell>
                  );
                })}
              </TblBodyRow>
            );
          })}
        </TblBody>
      </Tbl>{" "}
    </>
  );
};

export default WorkflowInputTable;
